import { render, staticRenderFns } from "./quotation_result.vue?vue&type=template&id=4014130b&scoped=true"
import script from "./quotation_result.vue?vue&type=script&lang=js"
export * from "./quotation_result.vue?vue&type=script&lang=js"
import style0 from "./quotation_result.vue?vue&type=style&index=0&id=4014130b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014130b",
  null
  
)

export default component.exports